import '@mrhenry/wp--bugsnag-config';
import '@mrhenry/wp--autoplay-in-view';

import './modules/backflash-frame-tool';
import './modules/brush-nugget';
import './modules/group';
import './modules/hls';
import './modules/input-sink';
import './modules/link-color';
import './modules/magic-cursor';
import './modules/mr-blocked-content';
import './modules/mr-navigation-modal';
import './modules/mr-nth-carousel';
import './modules/mute-toggle';
import './modules/nightfall-3d-model';
import './modules/stream-translator';
import './modules/video-background';
import './modules/window-watcher';
import './modules/windows98/draggeable';
import './modules/windows98/file-toggle';
import './modules/windows98/files-stack';
import './modules/windows98/folder-link';


import { MrCarousel, MrDisplayValue, MrMatchesValue } from '@mrhenry/wp--mr-interactive';

customElements.define( 'mr-carousel', MrCarousel );
customElements.define( 'mr-display-value', MrDisplayValue );
customElements.define( 'mr-matches-value', MrMatchesValue );
